var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20964 7.49408L13.6326 1.70533C13.9039 1.3606 14.2245 1.10144 14.5942 0.927826C14.9639 0.753937 15.3496 0.666992 15.7513 0.666992C16.153 0.666992 16.5317 0.753937 16.8876 0.927826C17.2434 1.10144 17.557 1.3606 17.8284 1.70533L22.2513 7.49408L29.0588 9.73741C29.6338 9.94908 30.0777 10.2806 30.3905 10.732C30.7035 11.1837 30.8601 11.6912 30.8601 12.2545C30.8601 12.5253 30.8234 12.7882 30.7501 13.0432C30.6767 13.2982 30.5542 13.5478 30.3826 13.792L25.9788 19.8112L26.1455 26.337C26.1455 27.1034 25.8839 27.7527 25.3609 28.2849C24.8381 28.8174 24.2151 29.0837 23.4917 29.0837C23.4681 29.0837 23.2309 29.0473 22.7801 28.9745L15.7096 26.9649L8.63922 28.9745C8.50033 29.0301 8.37783 29.0621 8.27172 29.0707C8.16561 29.0794 8.05089 29.0837 7.92755 29.0837C7.19672 29.0837 6.56477 28.8174 6.03172 28.2849C5.49866 27.7527 5.24602 27.1034 5.2738 26.337L5.44047 19.8112L1.02047 13.792C0.848802 13.5467 0.726302 13.303 0.652969 13.0607C0.579635 12.8182 0.542969 12.562 0.542969 12.292C0.542969 11.7189 0.705191 11.1969 1.02964 10.7257C1.35408 10.2546 1.81686 9.91991 2.41797 9.72158L9.20964 7.49408Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.ed0bc24c90128fa75bbb930b033cfc5d.svg";
export { ForwardRef as ReactComponent };